<template>
  <div class="more-programs-wrapper">
    <p class="more-programs-title">Еще вас может заинтересовать</p>
    <div
      class="more-programs-item"
      v-for="program in itemsToShow"
      :key="program.id"
    >
      <p class="more-programs-item-title" @click="program.isSelected = !program.isSelected">{{ program.title }}</p>
      <ToggleSwitch v-model="program.isSelected" />
    </div>
    <button
      v-if="programsPersonalCheckup.length > 4 && !isExpanded"
      class="program-sign-up__button--transparent"
      @click.prevent="isExpanded = true"
    >
      Больше услуг
    </button>
  </div>
</template>

<script setup>
import { computed, ref, watch, defineProps, defineEmits } from 'vue'
import ToggleSwitch from './ToggleSwitch.vue'
const props = defineProps(['programsPersonalCheckup'])
const emit = defineEmits(['handleProgramGroupUpdate'])

const isExpanded = ref(false)

const itemsToShow = computed(() => {
  if (isExpanded.value) {
    return props.programsPersonalCheckup
  } else {
    return props.programsPersonalCheckup.slice(0, 4)
  }
})

watch(
  props.programsPersonalCheckup,
  () => {
    emit('handleProgramGroupUpdate', props.programsPersonalCheckup)
  },
  { deep: true }
)
</script>

<style scoped>
.more-programs-wrapper {
  border-radius: 6px;
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #e1e8f4;
  margin-bottom: 26px;
}
.more-programs-title {
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #002856;
}

.more-programs-item {
  display: flex;
  justify-content: space-between;
}
.more-programs-item-title {
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #002856;
  cursor: pointer;
}

.program-sign-up__button--transparent {
  font-size: 16px;
  font-weight: 400;
  line-height: 23.58px;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 30px;
  height: 50px;
  width: 100%;
  text-transform: uppercase;
  color: #002856;
  margin-top: auto;
  transition: all 0.2s ease;
  border: 1px solid #002856;
}
</style>
